import { GQL } from 'src/graphql';
import { AdapterFunc } from 'src/hooks/useEntityAdapter';
import { CompanyIndustryModel } from 'src/models';

const companyIndustryAdapter: AdapterFunc<GQL.CompanyIndustryDbModel, CompanyIndustryModel> = (
  input,
) => ({
  id: input.id,
  name: input.name!,
  createdAt: input.createdAt,
  updatedAt: input.updatedAt,
  description: input.description!,
});

export default companyIndustryAdapter;
